import ModalLayout from "../layouts/ModalLayout";

interface Props {
  title?: string;
  description: string;
  icon: string;
  buttonText?: string;
  onClose: () => void;
}

export default function UpdateDetailsPayroll({
  title,
  description,
  icon,
  buttonText = "OK, Got It",
  onClose,
}: Props) {
  return (
    <ModalLayout onClose={onClose} isCross={false} width="max-w-[200px]">
      <div className="flex flex-col gap-4 items-center text-center">
        <img src={icon} alt="info" className="w-12 h-12" />

        {title && (
          <h4 className="text-lg font-semibold text-neutral-600">
            {title}
          </h4>
        )}

        <p className="text-neutral-500 text-[17px]">
          {description}
        </p>

        <button
          onClick={onClose}
          className="px-8 py-2 bg-primary-800 text-white rounded text-[13px] font-medium"
        >
          {buttonText}
        </button>
      </div>
    </ModalLayout>
  );
}
